import { isMobile, isTablet, isDesktop } from 'react-device-detect';

const getDeviceType = () => {
  if (isMobile || isTablet) return 'Mobile';
  if (isDesktop) return 'Desktop';
  return 'Desktop';
};

export const deviceType = getDeviceType();
